import type { ExcursionsComponentProps } from "@op/puck-types";
import { slug, useExcursionContext } from "@op/utils";
import { AnimatePresence, LazyMotion, m, domAnimation } from "framer-motion";
import { useMemo } from "react";
import { Excursion } from "../../../../../components/base/Excursion/Excursion";

const Excursions = ({ excursions }: ExcursionsComponentProps) => {
  const { openExcursions } = useExcursionContext();

  const renderedExcursions = useMemo(() => {
    return excursions.filter((excursion) =>
      openExcursions.includes(slug(excursion.data.root.props?.title ?? ""))
    );
  }, [excursions, openExcursions]);

  return (
    <div id="excursions">
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {renderedExcursions.map((excursion, index) => (
            <m.div
              key={`${excursion.slug}-${index}`}
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 1 }}
            >
              <Excursion
                key={`${excursion.slug}-${index}`}
                data={excursion.data}
                slug={excursion.slug}
                index={index}
              />
            </m.div>
          ))}
        </AnimatePresence>
      </LazyMotion>
    </div>
  );
};

export default Excursions;
